<script>
  import Field from '@leaflink/stash/Field.vue';

  import { money, percent } from '@/utils/i18n';

  export default {
    name: 'VolumeDiscountListItem',

    components: {
      Field,
    },

    props: {
      bulk: {
        type: Boolean,
      },

      discount: {
        type: Object,
        required: true,
      },
    },

    /**
     * Text to display in the discount list depending if the product is sold in bulk or not
     */
    computed: {
      discountText() {
        const amountOff = this.bulk ? 'brand_menu.amountOffPerCase' : 'brand_menu.amountOffPerUnit';
        const amountOffPerX = this.$t(amountOff, { amount: money({ amount: this.discount.price }) });
        const percent = this.percent(this.discount.percent / 100, 0);

        return `${amountOffPerX} (${this.$t('common.save')} ${percent})`;
      },
    },

    methods: {
      money,
      percent,
    },
  };
</script>

<template>
  <li class="ll-grid ll-grid-cols-4 ll-pa-1 bg-white align-middle" :class="$style.volume">
    <div>
      <Field> {{ discount.quantity }}+ </Field>
    </div>
    <div class="col-span-3">
      <Field>
        {{ discountText }}
      </Field>
    </div>
  </li>
</template>

<style lang="scss" module>
  .volume {
    margin-bottom: 1px;
  }
</style>
